// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simx-agreement {
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-height: 100%;
  padding: 30px;
  width: calc(100vw - 20%);
}
@media only screen and (min-width: 1024px) {
  .simx-agreement {
    min-height: 540px;
    width: 80vw;
  }
}

.simx-agreement--information-area {
  flex-shrink: 0;
}

.simx-agreement--divider {
  background-color: rgba(54, 47, 65, 0.1);
  border-radius: 4px;
  flex-shrink: 0;
  height: 3px;
}

.simx-agreement--name-area {
  display: flex;
  flex-shrink: 0;
  gap: 1rem;
}

.simx-agreement--agreement-name {
  font-weight: 600;
}

.simx-agreement--body-area {
  background-color: rgb(255, 255, 255);
  border-color: rgb(194.5833333333, 206.6666666667, 206.6666666667);
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  flex-grow: 1;
  overflow: hidden;
  width: 100%;
}

.simx-agreement--body {
  height: 100%;
  overflow-y: auto;
  padding: 10px;
}

.simx-agreement--action-area {
  display: flex;
  gap: 30px;
  justify-content: flex-end;
  padding-top: 15px;
  width: 100%;
}
.simx-agreement--action-area .simx-action-button {
  min-width: 125px;
}

.dialog-body {
  margin-bottom: 25px;
}

.dialog-action-buttons-area {
  display: flex;
  width: 100%;
  justify-content: center;
  gap: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/authentication/components/agreement/agreement.component.scss","webpack://./src/assets/styles/_colors.scss","webpack://./src/assets/styles/_theme.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,wBAAA;AAFF;AAIE;EARF;IASI,iBAAA;IACA,WAAA;EADF;AACF;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,uCAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;AADF;;AAIA;EACE,aAAA;EACA,cAAA;EACA,SAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,oCCvB8B;EDwB9B,iEC3B8B;ED4B9B,kBEzC4B;EF0C5B,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AADF;;AAIA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;AADF;;AAIA;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;AADF;AAGE;EACE,gBAAA;AADJ;;AAKA;EACE,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,WAAA;EACA,uBAAA;EACA,SAAA;AAFF","sourcesContent":["@use 'colors';\n@use 'theme';\n\n.simx-agreement {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  max-height: 100%;\n  padding: 30px;\n  width: calc(100vw - 20%);\n\n  @media only screen and (min-width: 1024px) {\n    min-height: 540px;\n    width: 80vw;\n  }\n}\n\n.simx-agreement--information-area {\n  flex-shrink: 0;  \n}\n\n.simx-agreement--divider {\n  background-color: rgba(colors.$simxColorDarkAccent,0.1);\n  border-radius: 4px;\n  flex-shrink: 0;\n  height: 3px;\n}\n\n.simx-agreement--name-area {\n  display: flex;\n  flex-shrink: 0;\n  gap: 1rem;\n}\n\n.simx-agreement--agreement-name {\n  font-weight: 600;\n}\n\n.simx-agreement--body-area {\n  background-color: colors.$simxColorControlBackground;\n  border-color: colors.$simxColorControlBorder;\n  border-radius: theme.$simxBorderRadiusDefault;\n  border-style: solid;\n  border-width: 1px;\n  flex-grow: 1;\n  overflow: hidden;\n  width: 100%;\n}\n\n.simx-agreement--body {\n  height: 100%;\n  overflow-y: auto;\n  padding: 10px;\n}\n\n.simx-agreement--action-area {\n  display: flex;\n  gap: 30px;\n  justify-content: flex-end;\n  padding-top: 15px;\n  width: 100%;\n\n  .simx-action-button {\n    min-width: 125px;\n  }\n}\n\n.dialog-body {\n  margin-bottom: 25px;\n}\n\n.dialog-action-buttons-area {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  gap: 1rem;\n}\n","@use 'sass:color';\n\n$simxColorBrightAccent:         rgb(229, 0, 44);  // Red\n$simxColorDarkAccent:           rgb(54, 47, 65);  // Purple\n$simxColorBrightGreen:          rgb(0, 201, 133);\n$simxColorMustard:              rgb(255, 177, 0);\n\n$simxColorDarkAccentMedium:     color.adjust($simxColorDarkAccent, $lightness: 6%);\n$simxColorDarkAccentLight:      color.adjust($simxColorDarkAccent, $lightness: 53%);\n$simxColorDarkNeutral:          rgb(21, 19, 25);\n$simxColorDarkNeutralLight:     color.adjust(color.adjust($simxColorDarkNeutral, $saturation: -7%), $lightness: 76%);\n$simxColorLightNeutral:         rgb(230, 235, 235);\n$simxColorLightNeutralLight:    color.adjust($simxColorLightNeutral, $lightness: 5%);\n$simxColorLightNeutralDark:     color.adjust($simxColorLightNeutral, $lightness: -12.5%);\n$simxColorLightNeutralDarker:   color.adjust($simxColorLightNeutral, $lightness: -25%);\n$simxColorLightNeutralDarkest:  color.adjust($simxColorLightNeutral, $lightness: -37.5%);\n$simxColorWhite:                rgb(255, 255, 255);\n\n$simxColorTextDefault:          $simxColorDarkNeutral;\n$simxColorTextLight:            rgb(166, 167, 169);\n$simxColorTextInvert:           rgba(255, 255, 255, 0.95);\n$simxColorTextOverDarkAccent:   rgba($simxColorWhite, 0.95);\n\n$simxColorControlBackground:    $simxColorWhite;\n$simxColorControlBorder:        $simxColorLightNeutralDark;\n","$simxBorderRadiusDefault:     4px;\n$simxBorderRadiusHeavy:       calc($simxBorderRadiusDefault * 2);\n\n$simxTransitionSpeedDefault:  0.2s;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
